import { Skeleton } from "@devhop/ui";
import { BanIcon, CheckCircle2Icon, ClockIcon } from "lucide-react";
import { SummaryCard } from "@/shared/ui/SummaryCard";
import { useMechanicStatsQuery } from "../api/queries";

export function MechanicsStatsCards() {
  const { data, isLoading } = useMechanicStatsQuery();

  if (isLoading) {
    return (
      <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-24 rounded-xl" />
        ))}
      </div>
    );
  }

  const stats = data ?? {
    pendingVerification: 0,
    active: 0,
    suspended: 0,
  };

  return (
    <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
      <SummaryCard
        title="ລໍຖ້າກວດສອບ"
        items={[
          { label: "", value: stats.pendingVerification.toLocaleString() },
        ]}
        gridCols={2}
        valueSpan={1}
        icon={ClockIcon}
        color="secondary"
        titleClassName="font-medium text-xs uppercase tracking-wider"
        contentClassName="font-bold text-2xl tracking-tight"
      />
      <SummaryCard
        title="ຊ່າງໃຊ້ງານປົກກະຕິ"
        icon={CheckCircle2Icon}
        items={[{ label: "", value: stats.active.toLocaleString() }]}
        gridCols={2}
        valueSpan={1}
        color="success"
        titleClassName="font-medium text-xs uppercase tracking-wider"
        contentClassName="font-bold text-2xl tracking-tight"
      />
      <SummaryCard
        title="ບັນຊີທີ່ລະງັບ"
        icon={BanIcon}
        items={[{ label: "", value: stats.suspended.toLocaleString() }]}
        gridCols={2}
        valueSpan={1}
        color="muted"
        titleClassName="font-medium text-xs uppercase tracking-wider"
        contentClassName="font-bold text-2xl tracking-tight"
      />
    </div>
  );
}
